// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"531":"496b2501","3567":"828d61eb","4632":"bd77b71b","5982":"235bc925","7204":"bd77b71b","8688":"9923b5b2"}[chunkId] + ".chunk.css";
};